import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'
import { toViewingProfileManagerValue } from '../RentalPortalViewingProfile.utils'

import { useViewingProfileHeaderInfoItems } from './RentalPortalViewingProfileHeaderInfoItems.hooks'
import {
  getHasViewingProfileApplicantList,
  getIsViewingProfileApplicantClickable,
  getViewingProfileApplicants,
  getViewingProfileHeaderApplicant,
} from './RentalPortalViewingProfileHeaderInfoItems.utils'
import { ViewingProfileApplicantItem } from './ViewingProfileApplicantItem'
import { ViewingProfileHeaderInfoItemsSkeleton } from './ViewingProfileHeaderInfoItemsSkeleton'
import { ViewingProfileManagerItem } from './ViewingProfileManagerItem'
import { ViewingProfileTimeItem } from './ViewingProfileTimeItem'

import * as styles from './RentalPortalViewingProfileHeaderInfoItems.module.css'

function RentalPortalViewingProfileHeaderInfoItems({ isLoading, isPreview }) {
  const { viewingData } = useViewingProfileContext()

  const { handleClickApplicant, handleClickApplicantItem } =
    useViewingProfileHeaderInfoItems({ isPreview })

  const applicant = getViewingProfileHeaderApplicant(viewingData)

  const isApplicantClickable = getIsViewingProfileApplicantClickable({
    applicant,
    viewingData,
  })

  const applicants = getViewingProfileApplicants(viewingData)

  const hasApplicantList = getHasViewingProfileApplicantList(applicants)

  return (
    <div className={styles.infoGrid}>
      {isLoading ? (
        <ViewingProfileHeaderInfoItemsSkeleton className={styles.infoItem} />
      ) : (
        <>
          <ViewingProfileTimeItem
            className={styles.infoItem}
            contentWrapperClassName={styles.contentWrapper}
            titleClassName={styles.infoItemTitle}
            viewing={viewingData}
          />
          <ViewingProfileApplicantItem
            applicant={applicant}
            applicants={applicants}
            className={isPreview ? styles.applicantsInfoItem : styles.infoItem}
            contentWrapperClassName={
              isApplicantClickable && !hasApplicantList
                ? styles.applicantContentWrapper
                : styles.contentWrapper
            }
            hasApplicantList={hasApplicantList}
            isClickable={isApplicantClickable}
            itemClassName={styles.applicantItem}
            titleClassName={styles.infoItemTitle}
            onClickApplicant={handleClickApplicant}
            onClickApplicantItem={handleClickApplicantItem}
          />
          <ViewingProfileManagerItem
            className={styles.infoItem}
            contentWrapperClassName={styles.contentWrapper}
            managerClassName={styles.managerItem}
            titleClassName={styles.infoItemTitle}
            value={toViewingProfileManagerValue(viewingData)}
          />
        </>
      )}
    </div>
  )
}

export default RentalPortalViewingProfileHeaderInfoItems
